import React from 'react';
import s from './s.modules.less';
import { TITLE, CONFIG } from './constants';

const Benefits: React.FC = () => {
    return (
        <div className={s.wrap}>
            <h2 className={s.title}>{TITLE}</h2>
            <div className={s.list}>
                {CONFIG.map((configItem) => {
                    return (
                        <div className={s.item}>
                            <h3 className={s.subTitle}>
                                <span className={s.svgWrap}>{configItem.image}</span>
                                {configItem.title}</h3>
                            <p className={s.description}>{configItem.description}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Benefits;
